import { createFileRoute, Outlet } from '@tanstack/react-router';

// ENG-1022: a top-level path, not `/imports/materials`, so the Work Order
// Imports and Material Imports nav items and crumbs never highlight together.
export const Route = createFileRoute('/material-imports')({
  staticData: {
    breadcrumb: 'Material Imports',
    layout: 'default',
    permissionSection: 'materials',
  },
  component: () => <Outlet />,
});
